import { withMotion } from '@hoc/withMotion';
import * as React from 'react';
import FilterDesktop from '../FilterDesktop/FilterDesktop';
import FilterMobile from '../FilterMobile/FilterMobile';
const Filter = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterDesktop, { ...props }),
        React.createElement(FilterMobile, { ...props })));
};
export default withMotion(Filter);
